import cities from '@/config/cities'

const getByCityCode = (cityCode, callback) => {
  if (!cityCode) return

  const [code, name, initials] = cities.find(array => array[0] === cityCode) || []
  if (!code) return

  if (typeof callback === 'function')
    return callback({ cityCode: code, initials, name })
  else
    return { cityCode: code, initials, name }
}

const table = () => {
  return cities.map(([cityCode, name, initials]) => ({
    cityCode,
    initials,
    name
  }))
}

const IBGE = {
  getByCityCode: getByCityCode,
  table: table()
}
export { IBGE }